module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress__bar",
    style: (_vm.transformPosition),
    attrs: {
      "role": "progressbar",
      "aria-valuemin": _vm.min,
      "aria-valuemax": _vm.max,
      "aria-valuenow": _vm.value
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6935924a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/components/item/components/progress/Progress.vue
// module id = d447f2ad7b5664ebfbd0
// module chunks = 89